import * as ort from "onnxruntime-web";
import logger from "src/utils/logger";

export const loadOnnxModel = async (modelName, numThreads = 1) => {
    try {
        ort.env.wasm.numThreads = numThreads;
        logger.log("Loading ONNX model from:", `${window.location.origin}/${modelName}`);

        const modelUrl = `${window.location.origin}/${modelName}`;
        const response = await fetch(modelUrl);
        
        if (!response.ok) {
            throw new Error(`Failed to fetch model: ${response.status} ${response.statusText}`);
        }

        const modelBuffer = await response.arrayBuffer();
        logger.log("Model downloaded, size:", modelBuffer.byteLength, "bytes");

        const session = await ort.InferenceSession.create(
            modelBuffer,
            {
                executionProviders: ['wasm'],
                graphOptimizationLevel: 'all'
            }
        );

        logger.log("ONNX model loaded successfully");
        logger.log("Input names:", session.inputNames);
        logger.log("Output names:", session.outputNames);

        return session;
    } catch (error) {
        logger.error("Error loading ONNX model:", error);
        logger.error("Model path:", `${window.location.origin}/${modelName}`);
        throw error;
    }
};

